import Pluralize from "pluralize";
var mixin = {
  methods: {
    edit(id) {
      this.$router.push({
        name: this.$route.meta.module + "-edit",
        params: { id: id }
      });
    },
    detail(id) {
      this.$router.push({
        name: this.$route.meta.module + "-detail",
        params: { id: id }
      });
    },
    async destroy(id) {
      let mod = this.$route.meta.module;
      let { value } = await this.$swal.fire({
        title: "Delete " + mod,
        html: "Are you sure you want to delete this " + mod + "?",
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No"
      });
      if (value) {
        this.$swal({
          title: "Deleting " + mod.toLowerCase() + "...",
          html: "this may only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          Pluralize(mod) + "/" + "DESTROY_" + mod.toUpperCase(),
          id
        );
        this.$swal({
          title: "Success",
          html: this.capitalizeFirstLetter(mod) + " has been deleted",
          icon: "info"
        });
        return true;
      }
      return false;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
export default mixin;
